export type LgPlatformCode = "MacOS" | "iOS" | "Windows" | "Android" | "Linux" | "Unknown";

let platformFound: LgPlatformCode | undefined = undefined;

export function detectPlatform(): LgPlatformCode {
    if (platformFound) return platformFound;

    const userAgent = window.navigator.userAgent;
    const platform = (
        (window.navigator as any).userAgentData?.platform ||
        window.navigator.platform ||
        ""
    ).toLowerCase();
    const macosPlatforms = ["macintosh", "macintel", "macppc", "mac68k", "macos"];
    const windowsPlatforms = ["win32", "win64", "windows", "wince"];
    const iosPlatforms = ["iphone", "ipad", "ipod"];

    if (macosPlatforms.indexOf(platform) !== -1) {
        platformFound = "MacOS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        platformFound = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        platformFound = "Windows";
    } else if (/Android/.test(userAgent)) {
        platformFound = "Android";
    } else if (/linux/.test(platform)) {
        platformFound = "Linux";
    } else {
        platformFound = "Unknown";
    }

    return platformFound;
}
